/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let HotelO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M170.553344 398.109696v455.11168h170.667008V398.11072H170.553344z m0-56.889344h170.667008c31.418368 0 56.889344 25.469952 56.889344 56.889344v455.11168c0 31.419392-25.470976 56.889344-56.889344 56.889344H170.553344c-31.419392 0-56.889344-25.469952-56.889344-56.889344V398.11072c0-31.419392 25.469952-56.889344 56.889344-56.889344zM625.664 284.331008c15.710208 0 28.444672 12.735488 28.444672 28.444672v56.889344c0 15.709184-12.734464 28.444672-28.444672 28.444672-15.70816 0-28.443648-12.735488-28.443648-28.444672v-56.889344c0-15.709184 12.734464-28.444672 28.443648-28.444672z m0 227.556352c15.710208 0 28.444672 12.735488 28.444672 28.444672v56.889344c0 15.70816-12.734464 28.443648-28.444672 28.443648-15.70816 0-28.443648-12.734464-28.443648-28.443648v-56.889344c0-15.709184 12.734464-28.444672 28.443648-28.444672z m113.778688-113.777664c15.709184 0 28.444672 12.734464 28.444672 28.443648v56.889344c0 15.709184-12.735488 28.444672-28.444672 28.444672s-28.444672-12.735488-28.444672-28.444672v-56.889344c0-15.70816 12.735488-28.443648 28.444672-28.443648z m0 227.555328c15.709184 0 28.444672 12.735488 28.444672 28.444672v56.889344c0 15.709184-12.735488 28.444672-28.444672 28.444672s-28.444672-12.735488-28.444672-28.444672v-56.889344c0-15.709184 12.735488-28.444672 28.444672-28.444672zM511.88736 170.553344v682.668032h341.334016V170.553344H511.88736z m0-56.889344h341.334016c31.419392 0 56.889344 25.469952 56.889344 56.889344v682.668032c0 31.419392-25.469952 56.889344-56.889344 56.889344H511.88736c-31.419392 0-56.889344-25.469952-56.889344-56.889344V170.553344c0-31.419392 25.469952-56.889344 56.889344-56.889344z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

HotelO.defaultProps = {
  size: 18,
};

HotelO = React.memo ? React.memo(HotelO) : HotelO;

export default HotelO;
